<template>
  <div class="col-sm-12 col-md">
    <abstract-profile-text-input
      id="input-personal_id"
      v-model="model"
      :error="errors"
      :label="computedLabel"
      :placeholder="computedPlaceholder"
      @change="inputChange"
      @input="onInput"
      :rules="required ? 'required' : ''"
    />
  </div>
</template>

<script>
import AbstractProfileTextInput from "../core/AbstractProfileTextInput";
import BaseInputMixin from "../../../../mixins/profileInputMixin";

export default {
  name: "PersonalId",
  components: {AbstractProfileTextInput},
  mixins: [BaseInputMixin('personal_id')],

  data() {
    return {
      defaultLabel: this.$t("Personal ID")
    }
  }
}
</script>

<style scoped>

</style>
